import { animate, group, style, transition, trigger } from "@angular/animations";

export const expandHeightAnimation = trigger("expandHeight", [
    transition(":enter", [
        style({ height: "0px", opacity: 0, padding: 0 }), // Initial state
        group([
            animate("300ms ease-out", style({ height: "*", padding: "*" })),
            animate("150ms ease-in", style({ opacity: 1 })),
        ]),

    ]),
    transition(":leave", [
        group([
            animate("300ms ease-out", style({ height: "0px", padding: "0px" })),
            animate("150ms ease-out", style({ opacity: 0 })),
        ]),
    // Collapsing state
    ]),
]);
